// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"107":"AppRouter","182":"QR"}[chunkId] || chunkId) + "." + {"107":"16127e3d","182":"4c54d44f","214":"0ee1fe1a","233":"4d2f4c5c","740":"eeba63ed"}[chunkId] + ".chunk.js";
};